import { IPaymentSetupData, ISubscriptionPaymentSummary } from 'fitbeat.models';
import produce from 'immer';
import { PaywallPage } from '../../auth';
import { PaymentActionTypes, types } from './payments-actions';

export const defaultState = {};

export interface IPaymentsState {
  haveCouponPressed: boolean;
  verifyingCouponInProgress: boolean;
  couponVerificationFailed: boolean;
  couponToApply: string;
  paymentSubscriptionSummary: ISubscriptionPaymentSummary | null;
  paymentSetupData: IPaymentSetupData | null;
  removeCouponInProgress: boolean;

  paywallModalVisible: boolean;
  paywallPage: null | PaywallPage;
  paywallOnCloseCallback: null | (() => void);
  paywallOnSuccessCallback: null | (() => void);
}

const initialPaymentsState: IPaymentsState = {
  haveCouponPressed: false,
  verifyingCouponInProgress: false,
  couponVerificationFailed: false,
  couponToApply: '',
  paymentSubscriptionSummary: null,
  paymentSetupData: null,
  removeCouponInProgress: false,

  paywallModalVisible: false,
  paywallPage: null,
  paywallOnCloseCallback: null,
  paywallOnSuccessCallback: null,
};

export const paymentReducer = produce(
  (draft: IPaymentsState = initialPaymentsState, action: PaymentActionTypes): IPaymentsState => {
    switch (action.type) {
      case types.HAVE_COUPON_PRESSED:
        draft.haveCouponPressed = true;
        break;
      case types.APPLY_COUPON_REQUEST:
        draft.verifyingCouponInProgress = true;
        draft.couponVerificationFailed = false;
        draft.couponToApply = action.payload.couponToApply;
        break;
      case types.APPLY_COUPON_SUCCESS:
        draft.verifyingCouponInProgress = false;
        draft.couponVerificationFailed = false;
        draft.haveCouponPressed = false;
        draft.paymentSetupData = action.payload.paymentSetupData;
        draft.paymentSubscriptionSummary = action.payload.paymentSubscriptionSummary;
        break;
      case types.APPLY_COUPON_FAILURE:
        draft.verifyingCouponInProgress = false;
        draft.couponVerificationFailed = true;
        break;
      case types.SUBSCRIPTION_SUMMARY_AND_PAYMENT_DATA_LOADED:
        draft.paymentSetupData = action.payload.paymentSetupData;
        draft.paymentSubscriptionSummary = action.payload.paymentSubscriptionSummary;
        break;
      case types.REMOVE_COUPON_REQUEST:
        draft.removeCouponInProgress = true;
        break;
      case types.REMOVE_COUPON_SUCCESS:
        draft.paymentSetupData = action.payload.paymentSetupData;
        draft.paymentSubscriptionSummary = action.payload.paymentSubscriptionSummary;
        draft.removeCouponInProgress = false;
        break;
      case types.REMOVE_COUPON_FAILURE:
        draft.removeCouponInProgress = false;
        break;
      case types.PAYWALL_MODAL_OPEN:
        draft.paywallModalVisible = true;
        draft.paywallPage = action.payload.paywallPage;
        draft.paywallOnCloseCallback = action.payload.paywallOnCloseCallback;
        draft.paywallOnSuccessCallback = action.payload.paywallOnSuccessCallback;
        break;
      case types.PAYWALL_MODAL_CLOSE:
        draft.paywallModalVisible = false;
        draft.paywallPage = null;
        draft.paywallOnCloseCallback = null;
        draft.paywallOnSuccessCallback = null;
        break;
    }
    return draft;
  });
